// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ot8TyxJvUgpoBz {
  text-align: center;
}
.VnA09bUTkTIqWU {
  height: 120px;
  margin-right: auto;
  margin-bottom: var(--ds-space-300, 24px);
  margin-left: auto;
}
.b8ggBdm13ShNkH {
  display: flex;
  align-items: center;
  justify-content: center;
}
.FX8nn9R8IGRhJ_ {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}
`, ""]);
// Exports
export var title = `Ot8TyxJvUgpoBz`;
export var headerImage = `VnA09bUTkTIqWU`;
export var description = `b8ggBdm13ShNkH`;
export var loading = `FX8nn9R8IGRhJ_`;
export default ___CSS_LOADER_EXPORT___;
